module.exports = __webpack_public_path__ + "static/media/duster.1ee57c79.svg";